import { useState } from 'react'
import {
  Box,
  Button,
  Container,
  TextField,
  Typography
} from '@mui/material'
import {
  ContactPageRounded
} from '@mui/icons-material'
import { useAuth } from '../providers/auth'
import { socket } from '..'
import { useNavigate } from 'react-router-dom'

export default function UserData() {
  const {user, setFirstTimeSignIn, currentRole} = useAuth()
  const navigate = useNavigate()
  const [displayName, setDisplayName] = useState<string>('')
  const [profilePictureUrl, setProfilePictureUrl] = useState<string>('')
  const [company, setCompany] = useState<string>('')

  return (
    <div>
      <Container maxWidth="xs" sx={{ marginTop: 5 }} >
        <Box
          mt={1}
          sx={{
            display: 'flex',
            alignItems: 'center'
          }}
        >
          <ContactPageRounded fontSize="large" color="disabled" />
          <Typography variant="h6" component="h1" ml={2}>
            User Data
          </Typography>
        </Box>

        <Typography variant="body1" component="p" mt={1}>
          Enter the data you want to be displayed on the platform. You can modify it later by accessing the account page.
        </Typography>

        <TextField
          fullWidth
          sx={{ marginTop: "1em" }}
          label={"Profile Picture Url"}
          value={profilePictureUrl}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            setProfilePictureUrl(event.target.value)
          }}
        />

        <TextField
          fullWidth
          sx={{ marginTop: "1em" }}
          label={"Display Name"}
          value={displayName}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            setDisplayName(event.target.value)
          }}
        />

        <TextField
          fullWidth
          sx={{ marginTop: "1em" }}
          label={"Company"}
          value={company}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            setCompany(event.target.value)
          }}
        />

        <Box mt={2}>
          <Button
            fullWidth
            size="large"
            variant="contained"
            onClick={() => {
              socket.emit('set_user_data', user!.uid, profilePictureUrl || "", displayName || "", company || "")
              setFirstTimeSignIn(false)
              if (currentRole !== "None" && currentRole !== "Blocked" && currentRole !== "User") {
                navigate('/embossers')
              } else {
                navigate('/')
              }
            }}
          >
            Save
          </Button>
        </Box>
      </Container>
    </div>
  )
}
